import * as React from 'react';

type LocationPinProps = {
  width?: number;
  height?: number;
};

export const LocationPin = (props: LocationPinProps) => (
  <svg width={props.width || 12} height={props.height || 18} viewBox='0 0 12 18' xmlns='http://www.w3.org/2000/svg'>
    <g stroke='#FFF' fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round'>
      <path
        d={`M8.725972 6.110546c0 1.603474-1.253333 2.903542-2.799166 2.903542-1.546112 \
        0-2.799167-1.300068-2.799167-2.903542 0-1.603475 1.253054-2.903543 2.799166-2.903543 1.545833 \
        0 2.799166 1.300068 2.799166 2.903543z`}
      />
      <path
        d={`M10.853806 6.110546c0 2.822288-4.926945 11.682457-4.926945 11.682457S.999918 \
        8.932833.999918 6.110546c0-2.822577 2.205833-5.11066 4.926944-5.11066 2.721112 \
        0 4.926946 2.288083 4.926946 5.11066z`}
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// src/app/src/components/Icons/LocationPin.tsx